import React, { useEffect, useRef, useContext, useState, useImperativeHandle } from 'react';
import gsap from 'gsap';
import DeepDive from './DeepDive';
import { DeepDiveData } from '../../data/Timing';
import { VideoContext } from '../../context/VideoContext';

const DeepDives = React.forwardRef(({open}, ref) => {

  const { overlays, setOverlays, setCurrentOverlay, currentDeepDiveIndex, deepDiveButtonRefs, lastEvent} = useContext(VideoContext);
  const deepDiveRefs = useRef([]);
  const containerRefs = useRef([]);
  const [deepDiveOpenIndex, setDeepDiveOpenIndex] = useState(-1);

  const closeDeepDive = (index) => {

    document.body.style.overflow = "auto";
    
    gsap.to( deepDiveRefs.current[index], {
      scale: 1, opacity: 0, duration: .5, ease: "expo.out",
      onComplete: () => {
        deepDiveRefs.current[index].classList.add("hidden");
        deepDiveRefs.current[index].classList.remove("block");
        setDeepDiveOpenIndex(-1);
      },
    });

    setOverlays({ ...overlays, visible: true });

    document.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').forEach(el => {
      el.setAttribute('tabindex', null);
    });

    let count = 0;
    deepDiveButtonRefs.current.forEach((el) => {
      if (count === index) {
        if (lastEvent === "mousedown") {
          el.focus();
        } else {
            el.contentEditable = true;
            el.focus();
            el.contentEditable = false;
        }
      }
      count++;
    });
    
  }

  // listen to changes in the VideoContext and open the Deep Dive when the VideoContext currentDeepDive index changes
  useEffect(() => {

    const openDeepDive = (index) => {

      document.body.style.overflow = "hidden";

      gsap.set( deepDiveRefs.current[index].querySelector(".vignette"), { opacity: 0 });
      gsap.set( deepDiveRefs.current[index], { scale: 0.8, opacity: 0 });
      gsap.to( deepDiveRefs.current[index], {
          scale: 1, 
          opacity: 1, 
          duration: .5, 
          ease: "expo.out",
          onStart: () => {
              deepDiveRefs.current[index].classList.add("block");
              deepDiveRefs.current[index].classList.remove("hidden");
          },
      });
      gsap.to( deepDiveRefs.current[index].querySelector(".vignette"), {
        opacity: .5, 
        duration: 1, 
        ease: "power3.out",
        delay: .25
      })
  
      setOverlays({ ...overlays, visible: false });
    
      setCurrentOverlay(`deepdive_${index}_0`);

      document.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').forEach(el => {
        el.setAttribute('tabindex', '-1');
      });

      deepDiveRefs.current[index].querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])').forEach(el => {
        el.setAttribute('tabindex', null);
      });

      deepDiveRefs.current[index].focus();
  
    }

    if (currentDeepDiveIndex !== null && currentDeepDiveIndex !== deepDiveOpenIndex) {
      openDeepDive(currentDeepDiveIndex);
      setDeepDiveOpenIndex(currentDeepDiveIndex);
    }

  }, [currentDeepDiveIndex, setCurrentOverlay, overlays, setOverlays ]);

  return (
    
    <div id="deepDiveContainer" ref={ref} className="opacity-100">

      {DeepDiveData.map((deepDive, index) => (

        <div 
          key={deepDive.id} 
          id={`deepDive-${deepDive.id}`}
          ref={(el) => (containerRefs.current[index] = el)} 
          className={`fixed inset-0 pointer-events-${currentDeepDiveIndex === index ? "all" : "none"} z-[999999]`}
        >

          <DeepDive 
            ref={(el) => (deepDiveRefs.current[index] = el)} 
            isOpen={overlays[index]} 
            onClose={() => closeDeepDive(index)}
            id={deepDive.id}
          >
            {deepDive.content}
          </DeepDive>

        </div>

      ))}
    </div>
    
  );
});

export default DeepDives;

